import { AssetLayout } from './types'

import { GiftCard } from './GiftCard'
import { Survey } from './Survey'
import { MarketingOptIn } from './MarketingOptIn'
import { CashAppServicingMessage } from './CashAppServicingMessage'

export type AssetComponent = AssetLayout & {
  GiftCard: AssetLayout
  Survey: AssetLayout
  MarketingOptIn: AssetLayout
  CashAppServicingMessage: AssetLayout
}

export const Asset = Survey as AssetComponent
Asset.GiftCard = GiftCard
Asset.Survey = Survey
Asset.MarketingOptIn = MarketingOptIn
Asset.CashAppServicingMessage = CashAppServicingMessage

export * from './types'
